// @ts-nocheck
import {
  GameController,
  Horse,
  Joystick,
  PokerChip,
  SoccerBall,
  Spade,
  SquaresFour,
  Ticket,
} from "@phosphor-icons/react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import adultsIcon from "../../../assets/images/footer-logos/adults-omly.svg";
import bitcoinIcon from "../../../assets/images/footer-logos/bitcoin.svg";
import championsIcon from "../../../assets/images/footer-logos/champion.svg";
import conalotIcon from "../../../assets/images/footer-logos/conalot.svg";
import gcbIcon from "../../../assets/images/footer-logos/gcb.svg";
import inhIcon from "../../../assets/images/footer-logos/inh.svg";
import laligaIcon from "../../../assets/images/footer-logos/laliga.svg";
import litecoinIcon from "../../../assets/images/footer-logos/litecoin.svg";
import lvbpIcon from "../../../assets/images/footer-logos/lvbp.svg";
import masterIcon from "../../../assets/images/footer-logos/master.svg";
import nbaIcon from "../../../assets/images/footer-logos/nba.svg";
import nflIcon from "../../../assets/images/footer-logos/nfl.svg";
import plus18Icon from "../../../assets/images/footer-logos/plus18.svg";
import secureIcon from "../../../assets/images/footer-logos/secure-encrypt.svg";
import visaIcon from "../../../assets/images/footer-logos/visa.svg";
import bgaming from "../../../assets/images/providers-logos/bgaming_c.svg";
import gamingcorps from "../../../assets/images/providers-logos/gamingcorps.svg";
import hacksaw from "../../../assets/images/providers-logos/hacksaw.svg";
import kaga from "../../../assets/images/providers-logos/kaga.svg";
import pixmove from "../../../assets/images/providers-logos/pixmove.svg";
import pragmatic from "../../../assets/images/providers-logos/pragmatic_c.svg";
import upgaming from "../../../assets/images/providers-logos/upgaming.svg";
import RGC_logo from "../../../assets/images/RGC_Logo.png";
import facebookIcon from "../../../assets/images/social-media/facebookIcon.svg";
import instagramIcon from "../../../assets/images/social-media/instagramIcon.svg";
import xIcon from "../../../assets/images/social-media/xIcon.svg";
import {SocialMedia} from "../../../config/config";
import {useAuthStore} from "../../../store/useAuth.store";
import {useUserSupport} from "../../../store/useUserSupport.store";
import {useBrandTitle, useLogo} from "../../../util/logoUtils";

const footerContainerCls =
  "flex flex-wrap justify-between items-start max-w-[1200px] py-10 px-6 my-0 mx-auto gap-x-12 gap-y-10 text-left [&_h3]:m-0 [&_h3]:text-(length:--font-body-lg) [&_h3]:font-semibold [&_h3]:tracking-tight [&_h3]:text-[var(--color-text)] [&_a]:no-underline [&_a]:text-inherit [&_a]:transition-colors [&_a]:duration-200 hover:[&_a]:text-[var(--color-primary)] hover:[&_a]:cursor-pointer max-md:justify-center max-md:text-center";
const footerContainerEachCls = "flex flex-col items-start gap-3 max-md:items-center";
const menuItemCls =
  "group flex items-center gap-2 py-1.5 px-2 -mx-2 rounded-lg text-[var(--color-text-secondary)] no-underline whitespace-nowrap transition-colors duration-200 hover:bg-[linear-gradient(90deg,rgb(250,84,0)_0%,rgb(215,50,168)_100%)] hover:text-[var(--color-ink-deep)] hover:shadow-[0_6px_18px_-8px_rgba(215,50,168,0.45)] [&_span]:text-(length:--font-body) [&_span]:whitespace-nowrap";
const menuIconCls =
  "inline-flex items-center justify-center w-6 h-6 text-white transition-colors duration-200 group-hover:text-[var(--color-ink-deep)] [&>svg]:w-full [&>svg]:h-full";
const menuGridContainerCls = "flex flex-col gap-3";
const sportsItemCls =
  "group flex flex-col items-center justify-center gap-1.5 p-2 rounded-lg no-underline transition-all duration-200 hover:-translate-y-0.5 hover:bg-[linear-gradient(90deg,rgb(250,84,0)_0%,rgb(215,50,168)_100%)] hover:shadow-[0_6px_18px_-8px_rgba(215,50,168,0.45)]";
const sportsIconCls = "w-9 h-9 object-contain";
const sportsIconNbaCls = "w-9 h-9 object-contain";
const supportListCls =
  "flex flex-col list-none gap-2 p-0 m-0 [&_li]:!font-normal [&_a]:!font-normal [&_a]:!text-white [&_a]:transition-colors [&_a]:duration-200 [&_a:hover]:!text-[var(--color-primary)] [&_a:hover]:cursor-pointer";
const socialIconsListContainerCls = "flex flex-col items-start gap-3 max-md:items-center";
const socialIconsCls = "flex gap-3 list-none justify-start pl-0 mx-0 my-0 max-md:justify-center";
const socialIconsImgCls =
  "h-5 w-5 my-2 mx-0 opacity-80 transition-opacity duration-200 hover:opacity-100";
const logoProviderContainerCls =
  "grid [grid-template-columns:repeat(auto-fit,minmax(120px,1fr))] justify-items-center items-center gap-8 max-w-[1200px] my-8 mx-auto px-6";
const logoProviderEachCls =
  "flex items-center justify-center p-3 h-[var(--size-15)] rounded-[var(--radius-md)] transition-[transform,filter] duration-200 grayscale-[60%] opacity-70 hover:grayscale-0 hover:opacity-100 hover:-translate-y-0.5 cursor-pointer";
const logoContainerCls =
  "flex gap-4 items-center justify-center py-6 px-4 max-w-[1200px] mx-auto [&_img]:w-[var(--size-25)] [&_h4]:m-0 [&_h4]:text-(length:--font-body-lg) [&_h4]:text-[var(--color-text-secondary)] [&_h4]:font-medium";
const rygFooterLogoCls = "w-[124px] h-[102px]";
const paymentLogosContainerCls =
  "flex flex-wrap justify-center items-center gap-6 max-w-[1200px] mx-auto my-8 py-4 px-4";
const paymentLogoCls =
  "h-10 w-auto object-contain opacity-70 transition-opacity duration-200 hover:opacity-100 max-[480px]:h-7";
const legalLinksContainerCls =
  "flex flex-wrap justify-center items-center gap-x-1 gap-y-2 max-w-[1100px] mx-auto px-6 pt-4 pb-6 mb-8 text-center";
const legalLinkCls =
  "font-['Open_Sans',sans-serif] font-normal text-(length:--font-body) leading-5 !text-white no-underline whitespace-nowrap transition-colors duration-200 hover:!text-[var(--color-primary)] hover:underline";
const legalSeparatorCls =
  "font-['Open_Sans',sans-serif] font-normal text-(length:--font-body) leading-5 text-[var(--color-text-secondary)] opacity-50 mx-1.5 select-none";
const footerDividerCls =
  "max-w-[1200px] mx-auto my-0 border-0 border-t border-[var(--color-border-subtle)]";

const FooterRyg = () => {
  const brandTitle = useBrandTitle();
  const logo = useLogo();
  const providerLogos = [
    {name: "hacksaw", img: hacksaw},
    {name: "bgaming", img: bgaming},
    {name: "kaga", img: kaga},
    {name: "pixmove", img: pixmove},
    {name: "pragmatic", img: pragmatic},
    {name: "upgaming", img: upgaming},
    {name: "gamingcorps", img: gamingcorps},
  ];

  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);

  const authStatus = useAuthStore(state => state.authStatus);

  const {t} = useTranslation();
  const navigate = useNavigate();

  // Function to navigate and scroll to top
  const navigateAndScrollToTop = path => {
    navigate(path);
    // Delay scroll to ensure navigation completes first
    setTimeout(() => {
      window.scrollTo({top: 0, behavior: "smooth"});
    }, 100);
  };

  const handleSupportModal = useUserSupport(state => state.handleSupportModal);

  return (
    <div>
      <div className={logoProviderContainerCls}>
        {providerLogos.map(({name, img}) => (
          <div
            key={name}
            className={logoProviderEachCls}
            onClick={() => navigateAndScrollToTop(`/games/provider/${name}`)}
            style={{cursor: "pointer"}}
          >
            <img
              src={img}
              alt={name}
            />
          </div>
        ))}
      </div>
      <hr className={footerDividerCls} />
      <div className={logoContainerCls}>
        <a
          href="https://www.responsiblegambling.org/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={RGC_logo}
            alt="rgc logo"
          />
        </a>
        <img
          src={plus18Icon}
          alt="18+ icon"
          style={{width: "var(--size-11)", height: "var(--size-11)"}}
        />
        <h4>{t("footerTitleResponsibleGambling")}</h4>
      </div>

      <div className={footerContainerCls}>
        <div className={footerContainerEachCls}>
          <h3 style={{marginBottom: "var(--space-2-5)", textAlign: "center"}}>{t("footerTitleGame")}</h3>
          <div
            className={menuGridContainerCls}
            style={{flexDirection: "row", gap: "var(--space-6)", alignItems: "flex-start"}}
          >
            {/* Column 1: Mini juegos, Lotería, Casino en vivo */}
            <div style={{display: "flex", flexDirection: "column", gap: "var(--space-3-5)"}}>
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/gameslist/all")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Joystick weight="fill" />
                  </span>
                  <span>{t("footerTitleGameGames")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Joystick weight="fill" />
                  </span>
                  <span>{t("footerTitleGameGames")}</span>
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/lottery")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Ticket weight="fill" />
                  </span>
                  <span>{t("footerTitleGameLottery")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Ticket weight="fill" />
                  </span>
                  <span>{t("footerTitleGameLottery")}</span>
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/casino")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Spade weight="fill" />
                  </span>
                  <span>{t("footerTitleGameCasino")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Spade weight="fill" />
                  </span>
                  <span>{t("footerTitleGameCasino")}</span>
                </div>
              )}
            </div>
            {/* Column 2: Deportes, Hipismo, E-Sports */}
            <div style={{display: "flex", flexDirection: "column", gap: "var(--space-3-5)"}}>
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/sports")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <SoccerBall weight="fill" />
                  </span>
                  <span>{t("footerTitleSports")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <SoccerBall weight="fill" />
                  </span>
                  <span>{t("footerTitleSports")}</span>
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/horses")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Horse weight="fill" />
                  </span>
                  <span>{t("footerTitleGameHorses")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <Horse weight="fill" />
                  </span>
                  <span>{t("footerTitleGameHorses")}</span>
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/games/pragmatic/vplobby")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <GameController weight="fill" />
                  </span>
                  <span>{t("footerTitleLigaEsports")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <GameController weight="fill" />
                  </span>
                  <span>{t("footerTitleLigaEsports")}</span>
                </div>
              )}
            </div>
            {/* Column 3: Slots, Juegos de mesa */}
            <div style={{display: "flex", flexDirection: "column", gap: "var(--space-3-5)"}}>
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/games/category/slots")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <PokerChip weight="fill" />
                  </span>
                  <span>{t("footerTitleGameSlots")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <PokerChip weight="fill" />
                  </span>
                  <span>{t("footerTitleGameSlots")}</span>
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={menuItemCls}
                  onClick={() => navigateAndScrollToTop("/games/category/table")}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <SquaresFour weight="fill" />
                  </span>
                  <span>{t("footerTitleGameMesa")}</span>
                </div>
              ) : (
                <div
                  className={menuItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <span
                    className={menuIconCls}
                    aria-hidden="true"
                  >
                    <SquaresFour weight="fill" />
                  </span>
                  <span>{t("footerTitleGameMesa")}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={footerContainerEachCls}>
          <h3 style={{marginBottom: "var(--space-2-5)", textAlign: "center"}}>{t("footerTitleLiga")}</h3>
          <div style={{display: "flex", flexDirection: "row", gap: "var(--space-2-5)"}}>
            {/* Column 1: Champions, LaLiga */}
            <div style={{display: "flex", flexDirection: "column", gap: "var(--space-2-5)"}}>
              {authStatus === "authenticated" ? (
                <div
                  className={sportsItemCls}
                  onClick={() => navigateAndScrollToTop("/sports?page=uefa-champions")}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={championsIcon}
                    alt="champions"
                    className={sportsIconCls}
                  />
                </div>
              ) : (
                <div
                  className={sportsItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={championsIcon}
                    alt="champions"
                    className={sportsIconCls}
                  />
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={sportsItemCls}
                  onClick={() => navigateAndScrollToTop("/sports?page=laliga")}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={laligaIcon}
                    alt="laliga"
                    className={sportsIconCls}
                  />
                </div>
              ) : (
                <div
                  className={sportsItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={laligaIcon}
                    alt="laliga"
                    className={sportsIconCls}
                  />
                </div>
              )}
            </div>
            {/* Column 2: NFL, LVBP */}
            <div style={{display: "flex", flexDirection: "column", gap: "var(--space-2-5)"}}>
              {authStatus === "authenticated" ? (
                <div
                  className={sportsItemCls}
                  onClick={() => navigateAndScrollToTop("/sports?page=nfl")}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={nflIcon}
                    alt="nfl"
                    className={sportsIconCls}
                  />
                </div>
              ) : (
                <div
                  className={sportsItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={nflIcon}
                    alt="nfl"
                    className={sportsIconCls}
                  />
                </div>
              )}
              {authStatus === "authenticated" ? (
                <div
                  className={sportsItemCls}
                  onClick={() => navigateAndScrollToTop("/sports?page=lvbp")}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={lvbpIcon}
                    alt="lvbp"
                    className={sportsIconCls}
                  />
                </div>
              ) : (
                <div
                  className={sportsItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={lvbpIcon}
                    alt="lvbp"
                    className={sportsIconCls}
                  />
                </div>
              )}
            </div>
            {/* Column 3: NBA */}
            <div style={{display: "flex", flexDirection: "column", gap: "var(--space-2-5)"}}>
              {authStatus === "authenticated" ? (
                <div
                  className={sportsItemCls}
                  onClick={() => navigateAndScrollToTop("/sports?page=nba")}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={nbaIcon}
                    alt="nba"
                    className={sportsIconNbaCls}
                  />
                </div>
              ) : (
                <div
                  className={sportsItemCls}
                  onClick={handleShowAuthModal}
                  style={{cursor: "pointer"}}
                >
                  <img
                    src={nbaIcon}
                    alt="nba"
                    className={sportsIconNbaCls}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div>
          <h3>Eventos</h3>
          <ul className={eventsListCls}>
            <li>Eventos</li>
          </ul>
        </div> */}
        <div className={footerContainerEachCls}>
          <h3 style={{marginBottom: "var(--space-2-5)", textAlign: "center"}}>{t("footerTitleSupport")}</h3>
          <ul className={supportListCls}>
            <li>
              <a
                href="https://soporte.aprietaygana.com/hc/help/es"
                target="_blank"
                rel="noreferrer"
              >
                {t("footerTitleHelp")}
              </a>
            </li>
            <li>
              <a
                href="https://aprietaygana.com/terminos-y-condiciones"
                target="_blank"
                rel="noreferrer"
              >
                {t("footerTitleTerms")}
              </a>
            </li>
            <li>
              <a onClick={handleSupportModal}>{t("footerTitleSupport")}</a>
            </li>
            <li>
              <a
                href="https://soporte.aprietaygana.com/hc/help/es/categories/promociones"
                target="_blank"
                rel="noreferrer"
              >
                {t("footerTitlePromotions")}
              </a>
            </li>
          </ul>
        </div>
        <div className={footerContainerEachCls}>
          <div className={socialIconsListContainerCls}>
            <img
              src={logo}
              alt={`${brandTitle} Logo`}
              className={rygFooterLogoCls}
            />
            <ul className={socialIconsCls}>
              <li>
                <a
                  href={SocialMedia.FACEBOOK}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={facebookIcon}
                    alt="Facebook"
                    className={socialIconsImgCls}
                  />
                </a>
              </li>
              <li>
                <a
                  href={SocialMedia.X}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={xIcon}
                    alt="X"
                    className={socialIconsImgCls}
                  />
                </a>
              </li>
              <li>
                <a
                  href={SocialMedia.INSTAGRAM}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={instagramIcon}
                    alt="Instagram"
                    className={socialIconsImgCls}
                  />
                </a>
              </li>
            </ul>
          </div>
          <h3 style={{textAlign: "center", width: "100%"}}>{t("footerTitleSocial")}</h3>
        </div>
      </div>
      {/* <hr style={{border: "1px solid var(--color-deep-surface-navy)"}} />
      <p style={{fontFamily: "var(--font-family)", textAlign: "center"}}>
        {t("footerTitleApp")}
      </p> */}
      <div className={paymentLogosContainerCls}>
        <img
          src={adultsIcon}
          alt="Adults Only"
          className={paymentLogoCls}
        />
        <img
          src={inhIcon}
          alt="INH"
          className={paymentLogoCls}
        />
        <img
          src={conalotIcon}
          alt="Conalot"
          className={paymentLogoCls}
        />
        <img
          src={gcbIcon}
          alt="GCB"
          className={paymentLogoCls}
        />
        <img
          src={masterIcon}
          alt="Mastercard"
          className={paymentLogoCls}
        />
        <img
          src={visaIcon}
          alt="Visa"
          className={paymentLogoCls}
        />
        <img
          src={bitcoinIcon}
          alt="Bitcoin"
          className={paymentLogoCls}
        />
        <img
          src={litecoinIcon}
          alt="Litecoin"
          className={paymentLogoCls}
        />
        <img
          src={secureIcon}
          alt="Secure"
          className={paymentLogoCls}
        />
      </div>
      {/* <div className={footerDownloadCls}>
        <a href={DownloadApp.Apple} target="_blank" rel="noreferrer">
          <img src={appLogo} alt="" className={storeIconCls} />
        </a>
        <a href={DownloadApp.ANDROID} target="_blank" rel="noreferrer">
          <img src={playStore} alt="" className={storeIconCls} />
        </a>
      </div> */}
      {/* <div className={footerCopyrightCls}>
        <p>
          {brandTitle} App ©{new Date().getFullYear()}
        </p>
      </div> */}
      <div className={legalLinksContainerCls}>
        {[
          "Reglas del Sistema",
          "Reglas del Sportbook",
          "Cuentas, Pagos y Bonos",
          "Identidad y Verificación de Clientes",
          "Juego Responsable",
          "Política de Privacidad",
          "Métodos de Pruebas y Equidad",
          "Política Contra Lavado de Dinero",
          "Resolución de Disputas",
          "Política de Autoexclusión",
          "Términos y Condiciones",
        ].map((label, index, arr) => (
          <span key={label}>
            <span className={legalLinkCls}>{label}</span>
            {index < arr.length - 1 && <span className={legalSeparatorCls}>|</span>}
          </span>
        ))}
      </div>
    </div>
  );
};

export default FooterRyg;
